/**
 * Logique de recherche : appel API, calcul de correspondance, démo / secours
 */

import { useCallback } from "react";
import { translateToEnglish } from "../utils/translateToEnglish.js";
import { fetchFridgeRecipes } from "../services/fetchFridgeRecipes.js";
import { computeMatchForRecipes } from "../services/computeMatch.js";
import { getDemoRecipes, getEmergencyRecipe } from "../data/demoRecipes.js";

export function useFridgeSearch(
  availableIngredients,
  minMatchPercentage,
  categories,
  countries,
  setMatchingRecipes,
) {
  const runSearch = useCallback(async () => {
    try {
      const uniqueRecipes = await fetchFridgeRecipes(
        availableIngredients,
        categories,
        countries,
        translateToEnglish,
      );
      const results = computeMatchForRecipes(
        uniqueRecipes,
        availableIngredients,
        minMatchPercentage,
      );

      if (results.length === 0) {
        setMatchingRecipes(getDemoRecipes(availableIngredients));
      } else {
        setMatchingRecipes(results);
      }
    } catch (error) {
      console.error("❌ Erreur API Internet:", error);
      setMatchingRecipes([getEmergencyRecipe(availableIngredients)]); // tableau pour cohérence
    }
  }, [
    availableIngredients,
    minMatchPercentage,
    categories,
    countries,
    setMatchingRecipes,
  ]);

  return runSearch;
}
